import "./contact-me.css";
import ButtonRow from "./components/button-row";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

const links = [
  {
    href: "https://www.facebook.com/mild.shiroyuno/",
    label: "✈ Facebook",
  },
  {
    href: "https://www.instagram.com/mildmis4ki/",
    label: "Instagram ☘︎",
  },
  {
    href: "https://www.instagram.com/maiii_uwu_/",
    label: "Private Instagram ☘︎",
  },
  { href: "#", label: "✉ E-mail : littleprince415@gmail.com" },
  { href: "https://www.deviantart.com/mildmisaki", label: "Deviantart" },
];

const supportLinks = [
  { href: "https://www.paypal.com/paypalme/Mildmis4ki", label: "PayPal" },
  { href: "#", label: "Thai Acc" },
  { href: "https://buymeacoffee.com/mildmisaki", label: "Buy me coffee" },

  { href: "https://ko-fi.com/mildmisaki", label: "KO-FI" },
];

function ContactMe() {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [listVisible, setListVisible] = useState(false);

  useEffect(() => {
    const imageTimer = setTimeout(() => setImageLoaded(true), 200);
    const listTimer = setTimeout(() => setListVisible(true), 250);
    return () => {
      clearTimeout(imageTimer);
      clearTimeout(listTimer);
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>✧･ﾟcontact-me･ﾟ✧</title>
      </Helmet>
      <div className="image-section">
        <img
          className={`home-image ${imageLoaded ? "fade-in" : ""}`}
          src="https://img5.pic.in.th/file/secure-sv1/-1058_20230623151426-1.png"
          alt="ไม่มีชื่อ 1058 20230623151426 (1)"
        />
        <h1 className="home-title">M I L D M I S A K I</h1>
      </div>
      <ButtonRow />
      <div className={`fade-up ${listVisible ? "show" : ""}`}>
        <h1 className="header-semireal-gl">✧･ﾟCONTACT ME･ﾟ✧</h1>
      </div>
      <div className={`fade-up ${listVisible ? "show" : ""}`}>
        <div className="contact-button-container">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="contact-button">{link.label}</button>
            </a>
          ))}
        </div>
      </div>
      <div className={`fade-up ${listVisible ? "show" : ""}`}>
        <div className="support-button-container">
          <div className={`fade-up ${listVisible ? "show" : ""}`}>
            <h1 className="header-semireal-gl">✧･ﾟSUPPORT ME･ﾟ✧</h1>
          </div>
          {supportLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="support-button">{link.label}</button>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ContactMe;
